import { useQuery } from '@tanstack/react-query';

import authAxios from '../../components/authAxios';

/* Single seam for the mobile home screen's data.

   Live: GET loans/dashboard/ — portfolio summary, counts and the newest
   5 applications. Own query key, so it can't collide with the desktop
   dashboard's ['dashboard'] cache.

   Amounts shown are AMOUNT APPLIED. amount_approved is carried through
   as approvedAmount for later use, but nothing displays it yet.

   on_time_rate is 0–100 (one decimal) and null when the client has no
   due instalments — onTimePct stays null then, never 0.

   User initials are still a placeholder: nothing on the client knows
   the logged-in user's name. */

const toApplication = (row) => ({
    id: row.id,
    name: row.customer_name,
    product: row.product_name,
    amount: Number(row.amount_applied),
    approvedAmount: row.amount_approved === null ? null : Number(row.amount_approved),
    // `status` is the code (colour); `statusLabel` is the text shown.
    status: row.status,
    statusLabel: row.status_display,
});

const toHomeData = ({ portfolio, counts, recent_applications }) => ({
    portfolio: {
        outstanding: Number(portfolio.outstanding),
        onTimePct: portfolio.on_time_rate === null ? null : Number(portfolio.on_time_rate),
        activeLoans: portfolio.active_loans,
    },
    counts: {
        newApplications: counts.new_applications,
        customers: counts.customers,
    },
    recentApplications: recent_applications.map(toApplication),
});

const useHomeData = () => {
    const { data, isLoading, isError, refetch } = useQuery({
        queryKey: ['dashboard', 'mobile'],
        queryFn: async () => {
            const response = await authAxios.get('/loans/dashboard/');
            return toHomeData(response.data);
        },
        // Fail fast so the Retry state shows instead of a long skeleton.
        retry: 1,
    });

    return {
        isLoading,
        isError,
        refetch,
        user: { initials: "JW" },
        ...data,
    };
};

export default useHomeData;
